module.exports = __webpack_public_path__ + "img/材料力学5_3_3.6f122e72.jpg";